import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import API from '../../utils/api';
import { printBill, downloadBill } from '../../utils/pdf';
import toast from 'react-hot-toast';

export default function MyBills() {
  const navigate = useNavigate();
  const [bills, setBills] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/bills').then(r => setBills(r.data)).catch(() => toast.error('Failed to load')).finally(() => setLoading(false));
  }, []);

  return (
    <Layout title="My Bills">
      <div style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 400px' : '1fr', gap: 24 }}>
        <div className="card">
          <div className="card-header"><span className="card-title">Bills Created By Me ({bills.length})</span></div>
          <div className="table-wrap">
            {loading ? <div style={{ padding: 40, textAlign: 'center', color: 'var(--gray-400)' }}>Loading...</div> :
              bills.length === 0 ? <div className="empty-state"><div className="empty-icon">🧾</div><div className="empty-title">No bills yet</div><div className="empty-text">Go to New Bill to create your first invoice</div></div> : (
                <table>
                  <thead><tr><th>Invoice No</th><th>Customer</th><th>Items</th><th>Total</th><th>Mode</th><th>Date</th><th></th></tr></thead>
                  <tbody>
                    {bills.map(b => (
                      <tr key={b.id} style={{ cursor: 'pointer', background: selected?.id === b.id ? 'var(--gold-pale)' : '' }}>
                        <td onClick={() => setSelected(b)}><strong style={{ color: 'var(--navy)' }}>{b.invoiceNo}</strong></td>
                        <td onClick={() => setSelected(b)}>{b.customer?.name}</td>
                        <td onClick={() => setSelected(b)}>{b.items?.length} item(s)</td>
                        <td onClick={() => setSelected(b)}><strong style={{ fontFamily: 'var(--font-display)', color: 'var(--gold)' }}>₹{b.total?.toFixed(2)}</strong></td>
                        <td onClick={() => setSelected(b)}><span className={`badge ${b.paymentMode === 'cash' ? 'badge-green' : b.paymentMode === 'card' ? 'badge-navy' : b.paymentMode === 'credit' ? 'badge-red' : b.paymentMode === 'discount' ? 'badge-amber' : 'badge-amber'}`}>{b.paymentMode}</span></td>
                        <td onClick={() => setSelected(b)}>{new Date(b.createdAt).toLocaleDateString('en-IN')}</td>
                        <td>
                          <div style={{ display: 'flex', gap: 4 }}>
                            <button className="btn btn-outline btn-sm" onClick={e => { e.stopPropagation(); downloadBill(b); }} title="Download PDF">⬇️</button>
                            <button className="btn btn-primary btn-sm" onClick={e => { e.stopPropagation(); printBill(b); }} title="Print">🖨️</button>
                            <button className="btn btn-success btn-sm" onClick={e => { e.stopPropagation(); navigate(`/billing?edit=${b.id}`); }} title="Edit Invoice">✏️</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
          </div>
        </div>

        {selected && (
          <div className="card fade-in">
            <div className="card-header">
              <div><div className="card-title">{selected.invoiceNo}</div><div style={{ fontSize: '0.78rem', color: 'var(--gray-500)', marginTop: 2 }}>{new Date(selected.createdAt).toLocaleString('en-IN')}</div></div>
              <button className="modal-close" onClick={() => setSelected(null)}>×</button>
            </div>
            <div className="card-body">
              <div style={{ marginBottom: 16, padding: '12px 14px', background: 'var(--gray-50)', borderRadius: 'var(--radius-md)' }}>
                <div style={{ fontWeight: 600, color: 'var(--navy)' }}>{selected.customer?.name}</div>
                <div style={{ fontSize: '0.82rem', color: 'var(--gray-500)' }}>{selected.customer?.phone}</div>
              </div>
              <table style={{ marginBottom: 12 }}>
                <thead><tr><th>Product</th><th>Qty</th><th>Price</th><th>Total</th></tr></thead>
                <tbody>
                  {(selected.items || []).map(item => {
                    const retQty = item.returnQty || item.return_qty || item.returnqty || 0;
                    const priceVal = item.price || item.unitRate || 0;
                    return (
                      <React.Fragment key={item.id}>
                        <tr>
                          <td>{item.productName}</td>
                          <td>{item.quantity}</td>
                          <td>₹{priceVal.toFixed(2)}</td>
                          <td><strong>₹{(item.quantity * priceVal).toFixed(2)}</strong></td>
                        </tr>
                        {retQty > 0 && (
                          <tr style={{ background: 'rgba(239, 68, 68, 0.05)', color: 'var(--red)' }}>
                            <td><span style={{ fontWeight: 'bold' }}>[RETURN]</span> {item.productName}</td>
                            <td>{retQty}</td>
                            <td>-₹{priceVal.toFixed(2)}</td>
                            <td><strong>-₹{(retQty * priceVal).toFixed(2)}</strong></td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
              <div style={{ borderTop: '2px solid var(--gold)', paddingTop: 10, textAlign: 'right' }}>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.3rem', color: 'var(--navy)', fontWeight: 700 }}>₹{selected.total?.toFixed(2)}</div>
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
                <button className="btn btn-outline" style={{ flex: 1 }} onClick={() => downloadBill(selected)}>⬇️ Download</button>
                <button className="btn btn-primary" style={{ flex: 1 }} onClick={() => printBill(selected)}>🖨️ Print</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
